enum Sprites {
  Ball = "ball",
  Floor = "floor",
  Hoop = "hoop",
  HoopFront = "hoop-front",
  Star = "star",
  ParticleBlue = "particle-blue",
  ParticleYellow = "particle-yellow",
}

export default Sprites;
